import { ModalContentProps } from "@chakra-ui/react";

export const Content : ModalContentProps ={
    w:"max-content",
    h:"max-content",
    maxW:"95%",
    maxH:"100%",
}